import "../src/init";

// Import bootstrap asynchronously to create an async boundary
// This allows Module Federation to initialize shared modules (React) before use
void import("./bootstrap");
